import { CARRY_ON, CHECK_IN } from '@/src/constants/itinerary/fareFamily'
import { PaxWiseBaggages } from '@/src/types/itinerary'
import { isEmpty } from '@/src/utils/generalUtils'
import { processBaggageData } from '@/src/utils/itinerary/fareFamily'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

// Types
type PassengerType = 'ADT'
type BaggageType = typeof CARRY_ON | typeof CHECK_IN

interface BaggageDataItem {
    type: BaggageType
    value: PaxWiseBaggages
}

interface PassengerData {
    ADT: string
}

interface ProcessedBaggageData {
    checkinData: PassengerData
    cabinData: PassengerData
}

interface UseBaggageDataReturn {
    processedData: ProcessedBaggageData
}

const useBaggageData = (baggageData: BaggageDataItem[]): UseBaggageDataReturn => {
    const t = useTranslations('common')
    const EMPTY_VALUE = t('Not allowed')

    const processedData = useMemo((): ProcessedBaggageData => {
        const checkinData: PassengerData = { ADT: EMPTY_VALUE }
        const cabinData: PassengerData = { ADT: EMPTY_VALUE }

        baggageData.forEach(({ type, value: paxWiseBaggages }) => {
            const { ADT } = paxWiseBaggages || {}
            const targetData = type === CHECK_IN ? checkinData : cabinData
            if (!isEmpty(ADT)) {
                const processed = processBaggageData(ADT)
                targetData['ADT'] = processed.displayValue || EMPTY_VALUE
            }
        })

        return {
            checkinData,
            cabinData
        }
    }, [baggageData])

    return {
        processedData
    }
}

export default useBaggageData
export type { BaggageDataItem, PassengerData, PassengerType, ProcessedBaggageData, UseBaggageDataReturn }
